import {createActions} from 'redux-actions';

export default createActions({
    SET_CURRENT_DATE: undefined,
});